<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="typeAdres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type adres </th>
        <td mat-cell *matCellDef="let row"> {{getAdresType(row.typeAdres)}}  </td>
    </ng-container>

    <ng-container matColumnDef="naam">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
        <td mat-cell *matCellDef="let row"> {{row.naam}} </td>
    </ng-container>
   
	<ng-container matColumnDef="adres1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Adres1 </th>
        <td mat-cell *matCellDef="let row"> {{row.adres1}} </td>
    </ng-container>

	<ng-container matColumnDef="postcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Postcode </th>
        <td mat-cell *matCellDef="let row"> {{row.postcode}} </td>
    </ng-container>

	<ng-container matColumnDef="plaats">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Plaats </th>
        <td mat-cell *matCellDef="let row"> {{row.plaats}} </td>
    </ng-container>

	<ng-container matColumnDef="land">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Land </th>
        <td mat-cell *matCellDef="let row"> {{row.landID?.omschrijving}} </td>
    </ng-container>
	
</mg-table>
